import { Navigate, useLocation } from "react-router-dom";
import PathConstants from "./path-constants";
import { useRequiredParams } from "shared/src/hooks/use-required-params";

const ReportAppealResultRedirect = () => {
  const { appealId } = useRequiredParams<"appealId">();
  const { search } = useLocation();
  return (
    <Navigate
      to={`${PathConstants.MyAppealsReportStatus.replace(":appealId", appealId)}${search}`}
      replace
    />
  );
};

const UploadApprovalLetterRedirect = () => {
  const { appealId } = useRequiredParams<"appealId">();
  return (
    <Navigate
      to={PathConstants.MyAppealsReportStatusUploadApprovalLetter.replace(
        ":appealId",
        appealId,
      )}
      replace
    />
  );
};

const DenialUpheldRedirect = () => {
  const { appealId } = useRequiredParams<"appealId">();
  return (
    <Navigate
      to={PathConstants.MyAppealsReportStatusDenialUpheld.replace(
        ":appealId",
        appealId,
      )}
      replace
    />
  );
};

const DenialUpheldClaimFileRedirect = () => {
  const { appealId } = useRequiredParams<"appealId">();
  return (
    <Navigate
      to={PathConstants.MyAppealsReportStatusDenialUpheldClaimFile.replace(
        ":appealId",
        appealId,
      )}
      replace
    />
  );
};

const reportStatusRedirects = [
  {
    path: PathConstants.ReportAppealResult,
    element: <ReportAppealResultRedirect />,
  },
  {
    path: PathConstants.UploadApprovalLetter,
    element: <UploadApprovalLetterRedirect />,
  },
  {
    path: PathConstants.DenialUpheld,
    element: <DenialUpheldRedirect />,
  },
  {
    path: PathConstants.DenialUpheldClaimFile,
    element: <DenialUpheldClaimFileRedirect />,
  },
  {
    path: PathConstants.AppealWon,
    element: <Navigate to={PathConstants.MyAppeals} replace />,
  },
  {
    path: PathConstants.ReviewAndShare,
    element: <Navigate to={PathConstants.MyAppeals} replace />,
  },
  {
    path: PathConstants.AppealLost,
    element: <Navigate to={PathConstants.MyAppeals} replace />,
  },
];

export default reportStatusRedirects;
